import { useQuery } from "@tanstack/react-query";
import { groupGet } from "common/api/citajteo/dl_group/citajteo_group";
import { QUERY_KEYS } from "constant/react_query";
import { DlGroup } from "model/dl_group/DlGroup";

export const useGroupGet = (
  id: string,
  searchBy: string = "id",
): DlGroup | null => {
  const { data: dlGroup } = useQuery(
    [QUERY_KEYS.CITAJTEO_DL_GROUP_GET, id, searchBy],
    async () => {
      const result = await groupGet(id, searchBy);
      return result;
    },
    { staleTime: Infinity, enabled: id !== "" },
  );
  const result = typeof dlGroup !== "undefined" ? dlGroup : null;
  return result;
};
